/**
 * GENERATED CODE
 * this file is generated by the 'process-icons' script.
 */
import React from 'react';
import { createSvgIcon } from '../utils';
export default createSvgIcon(React.createElement("g", { style: { transform: 'scaleY(-1)', transformOrigin: '50% 50%' } },
    React.createElement("path", { d: "M179.2 55.4668c0 0 -102.4 102.399 -110.934 110.934c-8.5332 8.5332 8.5332 25.5996 17.0664 17.0664l93.8672 -93.8672l247.467 247.467s25.5996 -8.5332 17.0664 -17.0664z" })), 'Checkmark', '0.00195312 64 512 512');
//# sourceMappingURL=CheckmarkIcon.js.map